module.exports = __webpack_public_path__ + "media/images/defaults/placeholder-aa64b67bf9ea336cd9adfc01484c4b14.png";